// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"DropdownMenu_dropdownMenu__+EnE5","dropItem":"DropdownMenu_dropItem__x46bs"};